import { render } from "./app-icon-pdf.vue?vue&type=template&id=605d6881"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/icon/app-icon-pdf.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "605d6881"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('605d6881', __exports__)) {
    console.log('reload')
    api.reload('605d6881', __exports__)
  }
  
  module.hot.accept("./app-icon-pdf.vue?vue&type=template&id=605d6881", () => {
    console.log('re-render')
    api.rerender('605d6881', render)
  })

}


export default __exports__